import { ColDef, ICellRendererParams } from 'ag-grid-community';
import {
  createBadgeCol,
  createCustomCol,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createIndexCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import CommunityPostingDto from '@/src/models/CommunityPostingDto';
import { formatter } from '@/src/utils/formatter';
import { UNIT_STRINGS } from '@/src/constants/unit';

export const communityPostingListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '작성 일시',
  }),
  createBadgeCol({
    field: 'communityReportType',
    options: [
      { label: '신고 접수', value: 'reception', color: 'lightYellow' },
      { label: '블라인드', value: 'blind', color: 'lightRed' },
      { label: '일반', value: 'common', color: 'lightPurple' },
    ],
    size: 'sm',
    headerName: '상태',
  }),
  createCustomCol({
    field: 'nick',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.nick || '-',
    headerName: '닉네임',
  }),
  createCustomCol({
    field: 'communityPostingCategoryTypeKr',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams<CommunityPostingDto>) =>
      data?.communityCategory?.categoryName || '-',
    headerName: '카테고리',
  }),
  createTypoCol({ field: 'title', size: 'lg', flex: 2, headerName: '제목' }),
  createCustomCol({
    field: 'counts',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams<CommunityPostingDto>) =>
      `${formatter.NUM_COMMA(
        data?.communityViewHistoryCount,
      )}/${formatter.NUM_COMMA(
        data?.communityCommentCount,
      )}/${formatter.NUM_COMMA(data?.communityLikeCount)}/${formatter.NUM_COMMA(
        data?.communityBookmarkCount,
      )}`,
    headerName: '조회/댓글/좋아요/북마크',
  }),
  createCustomCol({
    field: 'credit',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams<CommunityPostingDto>) => {
      return formatter.NUM_COMMA(data?.communityActiveHistories?.creditValue);
    },
    headerName: `지급 크레딧(${UNIT_STRINGS.CREDIT})`,
  }),
  createDetailButtonColV2(onDetailClick),
];

export const communityCommentListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '작성 일시',
  }),
  createBadgeCol({
    field: 'communityReportType',
    options: [
      { label: '신고 접수', value: 'reception', color: 'lightYellow' },
      { label: '블라인드', value: 'blind', color: 'lightRed' },
      { label: '일반', value: 'common', color: 'lightPurple' },
    ],
    size: 'sm',
    headerName: '상태',
  }),
  createCustomCol({
    field: 'nick',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.nick || '-',
    headerName: '닉네임',
  }),
  createTypoCol({ field: 'content', size: 'lg', flex: 2, headerName: '내용' }),
  createCustomCol({
    field: 'counts',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams) =>
      Number(data?.communityLikeCount || 0).toLocaleString(),
    headerName: '좋아요 수',
  }),
  createCustomCol({
    field: 'credit',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams<CommunityPostingDto>) => {
      return formatter.NUM_COMMA(data?.communityActiveHistories?.creditValue);
    },
    headerName: `지급 크레딧(${UNIT_STRINGS.CREDIT})`,
  }),
  createDetailButtonColV2(onDetailClick),
];

export const communityPostingDetailCommentListColumn: ColDef[] = [
  createIndexCol(),
  createTypoCol({ field: 'content', size: 'lg', flex: 2, headerName: '내용' }),
  createCustomCol({
    field: 'nick',
    size: 'md',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.nick || '-',
    headerName: '닉네임',
  }),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    headerName: '등록 일시',
  }),
];
